import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import { JobNames } from '../framework.core/JobNames';

export class HblStatusViewModel extends TrackableEntity {
    jobName: string = '';
    jobId: number = 0;
    createdBy: string = '';
    createdAt: string | null = null;
    updatedBy: string = '';
    updatedAt: string | null = null;
    operator: string = '';
    csr: string = '';
    oblCol: string = '';
    oblRcvd: boolean = false;
    oblDate: string | null = null;
    rlsd: boolean = false;
    rlsdBy: string = '';
    rlsDate: string | null = null;
    fileClosed: string = '';
    opClosed: boolean = false;
    opClosedBy: string = '';
    opCloseDate: string | null = null;
    actClosed: boolean = false;
    actClosedBy: string = '';
    actCloseDate: string | null = null;
    postDate: string | null = null;
    amsLinkId: number = 0;
    pimsLinkId: number = 0;
    commDocDate: string | null = null;
    commDocTime: string | null = null;
    commDocBy: string = '';
    commDocChk: boolean = false;
    entryDocDate: string | null = null;
    entryDocTime: string | null = null;
    entryDocBy: string = '';
    entryDocChk: boolean = false;
    f7501Date: string | null = null;
    f7501Time: string | null = null;
    f7501By: string = '';
    f7501Chk: boolean = false;
    f3461Date: string | null = null;
    f3461Time: string | null = null;
    f3461By: string = '';
    f3461Chk: boolean = false;
    puSentDate: string | null = null;
    puSentTime: string | null = null;
    puSentBy: string = '';
    puSentChk: boolean = false;
    delSchedDate: string | null = null;
    delSchedTime: string | null = null;
    delSchedBy: string = '';
    delSchedChk: boolean = false;
    delActDate: string | null = null;
    delActTime: string | null = null;
    delActBy: string = '';
    delActChk: boolean = false;
    podDate: string | null = null;
    podTime: string | null = null;
    podBy: string = '';
    podChk: boolean = false;
    billDate: string | null = null;
    billTime: string | null = null;
    billBy: string = '';
    billChk: boolean = false;
    billPacketDate: string | null = null;
    billPacketTime: string | null = null;
    billPacketBy: string = '';
    billPacketChk: boolean = false;
    trackerDate: string | null = null;
    trackerTime: string | null = null;
    trackerBy: string = '';
    trackerChk: boolean = false;
    lastTrackDate: string | null = null;
    lastTrackTime: string | null = null;
    lastTrackBy: string = '';
    lastTrackChk: boolean = false;
    emptyRetDate: string | null = null;
    emptyRetTime: string | null = null;
    emptyRetBy: string = '';
    emptyRetChk: boolean = false;
    anPrtDate: string | null = null;
    anPrtTime: string | null = null;
    anPrtBy: string = '';
    anPrtChk: boolean = false;
    inlandNtcDate: string | null = null;
    inlandNtcTime: string | null = null;
    inlandNtcBy: string = '';
    inlandNtcChk: boolean = false;
    doConfirmDate: string | null = null;
    doConfirmTime: string | null = null;
    doConfirmBy: string = '';
    doConfirmChk: boolean = false;
    doSentDate: string | null = null;
    doSentTime: string | null = null;
    doSentBy: string = '';
    doSentChk: boolean = false;
    delAddrDate: string | null = null;
    delAddrTime: string | null = null;
    delAddrBy: string = '';
    delAddrChk: boolean = false;
    ddpDate: string | null = null;
    ddpTime: string | null = null;
    ddpBy: string = '';
    ddpChk: boolean = false;
    examOnDate: string | null = null;
    examOnTime: string | null = null;
    examOnBy: string = '';
    examOnChk: boolean = false;
    examOffDate: string | null = null;
    examOffTime: string | null = null;
    examOffBy: string = '';
    examOffChk: boolean = false;
    hblNo: string = '';
    ror: boolean = false;
    oblBy: string = '';
    isRlsDate: boolean = false;
    customsStatus: string = '';
    isCClear: boolean = false;
    cClearDate: string | null = null;
    cClearBy: string = '';
    isCHold: boolean = false;
    cHoldDate: string | null = null;
    cHoldBy: string = '';
    isClear: boolean = false;
    cReleaseDate: string | null = null;
    cReleaseBy: string = '';
    fdaHold: boolean = false;
    fdaHoldDate: string | null = null;
    fdaHoldBy: string = '';
    fdaRls: boolean = false;
    fdaRlsDate: string | null = null;
    fdaRlsBy: string = '';
    issuedBy: string = '';
    issueDate: string | null = null;
    isRcvDoc: boolean = false;
    rcvDocDate: string | null = null;
    rcvDocDateBy: string = '';
    isRcvCargo: boolean = false;
    rcvCargoDate: string | null = null;
    rcvCargoDateBy: string = '';
    isDlvrCarr: boolean = false;
    dlvrCarrDate: string | null = null;
    dlvrCarrDateby: string = '';
    // For Aih
    lCode: string = '';
    etd: string | null = null;
    dCode: string = '';
    eta: string | null = null;
    storageDate: string | null = null;
    finalDest: string = '';
    fEta: string | null = null;
    goDate: string | null = null;
    carrierName: string = '';
    isRls: boolean = false;
    paidDate: string | null = null;
    rlsBy: string = '';
    anSentDate: string | null = null;
    anSentBy: string = '';
    anSentChk: boolean = false;
    firstTrackDate: string | null = null;
    firstTrackBy: string = '';
    firstTrackChk: boolean = false;
    fltNo: string = '';
    cargoOnBoard: string = '';
    cfsLocationName: string = '';

    constructor(init?:Partial<HblStatusViewModel>) {
        super();
        this.key=undefined;
        Object.assign(this, init);
        this.noTrackProps.push('jobName', 'jobId', 'createdBy', 'createdAt', 'updatedBy', 'updatedAt', 
        'operator', 'csr', 'oblRcvd', 'rlsd', 'fileClosed',
        'opClosed', 'opClosedBy', 'opCloseDate', 'actClosed', 'actClosedBy', 'actCloseDate',
        'postDate', 'amsLinkId', 'pimsLinkId', 'commDocTime', 'entryDocTime', 'f7501Time', 'f3461Time',
        'puSentTime', 'delSchedTime', 'delActTime', 'podTime', 'billTime', 'billPacketTime', 'trackerTime', 
        'lastTrackTime', 'emptyRetTime', 'anPrtTime', 'inlandNtcTime', 'doConfirmTime', 'doSentTime', 'delAddrTime', 
        'ddpTime', 'examOnTime', 'examOffTime', 'hblNo', 'ror', 'isRlsDate', 'lCode', 'etd', 'dCode', 'eta', 
        'storageDate', 'finalDest', 'fEta', 'goDate', 'carrierName', 'fltNo', 'issueDate', 'issuedBy');
    }

    getDbMappings(jobName:string):IDictionary<DBMappingInfo> {
        return HblStatusViewModel.getFieldMappings(jobName);
    }

    static _oihDicFieldMappings:IDictionary<DBMappingInfo> = {
        'commDocBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'commDocDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'commDocChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'entryDocBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'entryDocDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'entryDocChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'f7501By': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'f7501Date': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'f7501Chk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'f3461By': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'f3461Date': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'f3461Chk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'puSentBy': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'puSentDate': new DBMappingInfo({ field: 'F_D5', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'puSentChk': new DBMappingInfo({ field: 'F_N5', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'delSchedBy': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'delSchedDate': new DBMappingInfo({ field: 'F_D6', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'delSchedChk': new DBMappingInfo({ field: 'F_N6', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'delActBy': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'delActDate': new DBMappingInfo({ field: 'F_D7', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'delActChk': new DBMappingInfo({ field: 'F_N7', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'podBy': new DBMappingInfo({ field: 'F_C8', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'podDate': new DBMappingInfo({ field: 'F_D8', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'podChk': new DBMappingInfo({ field: 'F_N8', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'billBy': new DBMappingInfo({ field: 'F_C9', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'billDate': new DBMappingInfo({ field: 'F_D9', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'billChk': new DBMappingInfo({ field: 'F_N9', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'billPacketBy': new DBMappingInfo({ field: 'F_C10', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'billPacketDate': new DBMappingInfo({ field: 'F_D10', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'billPacketChk': new DBMappingInfo({ field: 'F_N10', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 15 }),
        'trackerBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'trackerDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'trackerChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetBy': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetDate': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetChk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'anPrtBy': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'anPrtDate': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'anPrtChk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'inlandNtcBy': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'inlandNtcDate': new DBMappingInfo({ field: 'F_D5', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'inlandNtcChk': new DBMappingInfo({ field: 'F_N5', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'doConfirmBy': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'doConfirmDate': new DBMappingInfo({ field: 'F_D6', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'doConfirmChk': new DBMappingInfo({ field: 'F_N6', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'doSentBy': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'doSentDate': new DBMappingInfo({ field: 'F_D7', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'doSentChk': new DBMappingInfo({ field: 'F_N7', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'delAddrBy': new DBMappingInfo({ field: 'F_C8', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'delAddrDate': new DBMappingInfo({ field: 'F_D8', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'delAddrChk': new DBMappingInfo({ field: 'F_N8', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'ddpBy': new DBMappingInfo({ field: 'F_C9', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'ddpDate': new DBMappingInfo({ field: 'F_D9', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'ddpChk': new DBMappingInfo({ field: 'F_N9', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 16 }),
        'examOnBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 17 }),
        'examOnDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 17 }),
        'examOnChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 17 }),
        'examOffBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 17 }),
        'examOffDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 17 }),
        'examOffChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 17 }),

        // For Oih
        'customsStatus': new DBMappingInfo({ field: 'F_CustomStatus', table: 'T_OIHMAIN' }),
        'cClearDate': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 17 }),
        'cClearBy': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 17 }),
        'cHoldDate': new DBMappingInfo({ field: 'CHoldDate', table: 'T_OIHMAIN' }),
        'cHoldBy': new DBMappingInfo({ field: 'CHoldBy', table: 'T_OIHMAIN' }),
        'isClear': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_OIHMAIN', tbId: '@TbId', type: 17 }),
        'cReleaseDate': new DBMappingInfo({ field: 'F_ClearDate', table: 'T_OIHMAIN' }),
        'cReleaseBy': new DBMappingInfo({ field: 'ClearBy', table: 'T_OIHMAIN' }),
        'fdaHold': new DBMappingInfo({ field: 'F_FDAHold', table: 'T_OIHMAIN' }),
        'fdaHoldDate': new DBMappingInfo({ field: 'FdaHoldDate', table: 'T_OIHMAIN' }),
        'fdaHoldBy': new DBMappingInfo({ field: 'FdaHoldBy', table: 'T_OIHMAIN' }),
        //'fdaRls': new DBMappingInfo({ field: 'FdaRls', table: 'T_OIHMAIN' }),
        'fdaRlsDate': new DBMappingInfo({ field: 'F_FDARlsDate', table: 'T_OIHMAIN' }),
        'fdaRlsBy': new DBMappingInfo({ field: 'FdaRlsBy', table: 'T_OIHMAIN' }),
        'oblCol': new DBMappingInfo({ field: 'F_OBLCOL', table: 'T_OIHMAIN' }),
        'oblDate': new DBMappingInfo({ field: 'F_OBLDATE', table: 'T_OIHMAIN' }),
        'oblBy': new DBMappingInfo({ field: 'OblBy', table: 'T_OIHMAIN' }),
        
        'rlsDate': new DBMappingInfo({ field: 'F_RLSDATE', table: 'T_OIHMAIN' }),
        'rlsdBy': new DBMappingInfo({ field: 'F_RELEASEBY', table: 'T_OIHMAIN' }),
    };

    static _aihDicFieldMappings:IDictionary<DBMappingInfo> = {
        'commDocBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'commDocDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'commDocChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'entryDocBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'entryDocDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'entryDocChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'f7501By': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'f7501Date': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'f7501Chk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'f3461By': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'f3461Date': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'f3461Chk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'puSentBy': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'puSentDate': new DBMappingInfo({ field: 'F_D5', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'puSentChk': new DBMappingInfo({ field: 'F_N5', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'delSchedBy': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'delSchedDate': new DBMappingInfo({ field: 'F_D6', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'delSchedChk': new DBMappingInfo({ field: 'F_N6', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'delActBy': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'delActDate': new DBMappingInfo({ field: 'F_D7', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'delActChk': new DBMappingInfo({ field: 'F_N7', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'podBy': new DBMappingInfo({ field: 'F_C8', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'podDate': new DBMappingInfo({ field: 'F_D8', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'podChk': new DBMappingInfo({ field: 'F_N8', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'billBy': new DBMappingInfo({ field: 'F_C9', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'billDate': new DBMappingInfo({ field: 'F_D9', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'billChk': new DBMappingInfo({ field: 'F_N9', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'billPacketBy': new DBMappingInfo({ field: 'F_C10', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'billPacketDate': new DBMappingInfo({ field: 'F_D10', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'billPacketChk': new DBMappingInfo({ field: 'F_N10', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 15 }),
        'trackerBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'trackerDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'trackerChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetBy': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetDate': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetChk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'anPrtBy': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'anPrtDate': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'anPrtChk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        // For Aih
        'anSentBy': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'anSentDate': new DBMappingInfo({ field: 'F_D5', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'anSentChk': new DBMappingInfo({ field: 'F_N5', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'firstTrackBy': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'firstTrackDate': new DBMappingInfo({ field: 'F_D6', table: 'T_AOTHERINFO', tbName: 'T_AIHMAIN', tbId: '@TbId', type: 16 }),
        'paidDate': new DBMappingInfo({ field: 'X_PAIDDATE', table: 'T_AIHMAIN' }),
        'rlsBy': new DBMappingInfo({ field: 'RlsBy', table: 'T_AIHMAIN' }),
        'isRls': new DBMappingInfo({ field: 'IsRls', table: 'T_AIHMAIN' }),

    };

    static _oehDicFieldMappings:IDictionary<DBMappingInfo> = {
        'trackerBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'trackerDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'trackerChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'lastTrackBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'lastTrackDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'lastTrackChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'emptyRetBy': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'emptyRetDate': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'emptyRetChk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'anPrtBy': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'anPrtDate': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'anPrtChk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'inlandNtcBy': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'inlandNtcDate': new DBMappingInfo({ field: 'F_D5', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'inlandNtcChk': new DBMappingInfo({ field: 'F_N5', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'doConfirmBy': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'doConfirmDate': new DBMappingInfo({ field: 'F_D6', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'doConfirmChk': new DBMappingInfo({ field: 'F_N6', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'doSentBy': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'doSentDate': new DBMappingInfo({ field: 'F_D7', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'doSentChk': new DBMappingInfo({ field: 'F_N7', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'delAddrBy': new DBMappingInfo({ field: 'F_C8', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'delAddrDate': new DBMappingInfo({ field: 'F_D8', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'delAddrChk': new DBMappingInfo({ field: 'F_N8', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'ddpBy': new DBMappingInfo({ field: 'F_C9', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'ddpDate': new DBMappingInfo({ field: 'F_D9', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'ddpChk': new DBMappingInfo({ field: 'F_N9', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'examOnBy': new DBMappingInfo({ field: 'F_C10', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'examOnDate': new DBMappingInfo({ field: 'F_D10', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        'examOnChk': new DBMappingInfo({ field: 'F_N10', table: 'T_AOTHERINFO', tbName: 'T_OOHMAIN', tbId: '@TbId', type: 15 }),
        //'isRcvDoc': new DBMappingInfo({ field: 'IsRcvDoc', table: 'T_OOHMAIN' }),
        'rcvDocDate': new DBMappingInfo({ field: 'rcvDocDate', table: 'T_OOHMAIN' }),
        'rcvDocDateBy': new DBMappingInfo({ field: 'rcvDocDateby', table: 'T_OOHMAIN' }),
        //'isRcvCargo': new DBMappingInfo({ field: 'IsRcvCargo', table: 'T_OOHMAIN' }),
        'rcvCargoDate': new DBMappingInfo({ field: 'rcvCargoDate', table: 'T_OOHMAIN' }),
        'rcvCargoDateBy': new DBMappingInfo({ field: 'rcvCargoDateBy', table: 'T_OOHMAIN' }),
        //'isDlvrCarr': new DBMappingInfo({ field: 'IsDlvrCarr', table: 'T_OOHMAIN' }),
        'dlvrCarrDate': new DBMappingInfo({ field: 'dlvrCarrDate', table: 'T_OOHMAIN' }),
        'dlvrCarrDateby': new DBMappingInfo({ field: 'dlvrCarrDateBy', table: 'T_OOHMAIN' }),

    };

    static _aehDicFieldMappings:IDictionary<DBMappingInfo> = {
        'trackerBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'trackerDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'trackerChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'lastTrackChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetBy': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetDate': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'emptyRetChk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'anPrtBy': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'anPrtDate': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'anPrtChk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'anSentBy': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'anSentDate': new DBMappingInfo({ field: 'F_D5', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'anSentChk': new DBMappingInfo({ field: 'F_N5', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'doConfirmBy': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'doConfirmDate': new DBMappingInfo({ field: 'F_D6', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'doConfirmChk': new DBMappingInfo({ field: 'F_N6', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'doSentBy': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'doSentDate': new DBMappingInfo({ field: 'F_D7', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'doSentChk': new DBMappingInfo({ field: 'F_N7', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'delAddrBy': new DBMappingInfo({ field: 'F_C8', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'delAddrDate': new DBMappingInfo({ field: 'F_D8', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'delAddrChk': new DBMappingInfo({ field: 'F_N8', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'ddpBy': new DBMappingInfo({ field: 'F_C9', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'ddpDate': new DBMappingInfo({ field: 'F_D9', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'ddpChk': new DBMappingInfo({ field: 'F_N9', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 16 }),
        'commDocBy': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'commDocDate': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'commDocChk': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'entryDocBy': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'entryDocDate': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'entryDocChk': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'f7501By': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'f7501Date': new DBMappingInfo({ field: 'F_D3', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'f7501Chk': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'f3461By': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'f3461Date': new DBMappingInfo({ field: 'F_D4', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'f3461Chk': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'cargoOnBoard': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'delSchedBy': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'delSchedDate': new DBMappingInfo({ field: 'F_D6', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),
        'delSchedChk': new DBMappingInfo({ field: 'F_N6', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TbId', type: 15 }),

    };

    // Called from View to make SQLList by passing arg
    static getFieldMappings = (jobName:string):IDictionary<DBMappingInfo> => {
        if(jobName === JobNames.OIHbl) return this._oihDicFieldMappings;
        else if(jobName === JobNames.AIHbl) return this._aihDicFieldMappings;
        else if(jobName === JobNames.OEHbl) return this._oehDicFieldMappings;
        else return this._aehDicFieldMappings;
    };
}
